import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

/**
 * A Material Design Icons (pictogrammers.com) glyph as a MUI icon, for the
 * motifs `@mui/icons-material` lacks — shovel, excavator, wheelbarrow.
 * `path` is an `mdi*` export of `@mdi/js`.
 */
export default function MdiIcon({
    path,
    ...props
}: SvgIconProps & { path: string }) {
    return (
        <SvgIcon {...props}>
            <path d={path} />
        </SvgIcon>
    );
}
